import { hitTestLatexOffset } from "@ever-tutor/et-ui";

export function hitTestCursorPosition(
  clientX: number,
  clientY: number,
  latexDisplay: HTMLElement,
  nodeCount: number,
): number | null {
  if (nodeCount === 0) return 0;

  const offset = hitTestLatexOffset(latexDisplay, clientX, clientY);
  if (offset == null || Number.isNaN(offset)) return null;

  // Clamp: a spaced text node serializes to multiple spans, so the raw index can overshoot.
  return Math.min(Math.max(offset, 0), nodeCount);
}
